import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getBreezeUrlPublic, getCommunityUrlPublic, getHubspotCreditsUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { handleClickFrequentlyAskedQuestionLink } from './trackFrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const breezePageLink = getBreezeUrlPublic();
const hubspotCreditsHref = getHubspotCreditsUrlPublic();
export const SmartCrmFaqs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatIsSmartCrm.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatIsSmartCrm.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howIsAIUsed.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howIsAIUsed.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          breezeLink: /*#__PURE__*/_jsx(Link, {
            href: breezePageLink,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.howIsAIUsed',
                url: breezePageLink,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howIsAIUsed.breezeLink"
            })
          }),
          hubSpotCreditsPageLink: /*#__PURE__*/_jsx(Link, {
            href: hubspotCreditsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.howIsAIUsed',
                url: hubspotCreditsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howIsAIUsed.hubSpotCreditsPageLink"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howDoesSmartCrmWork.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.howDoesSmartCrmWork.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.whatTypeOfSupport',
                url: communityHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.whatTypeOfSupport',
                url: langHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.whatTypeOfSupport',
                url: academyHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'smartCrm.whatTypeOfSupport',
                url: kbHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.smartCrm.whatTypeOfSupport.hubSpotKnowledgeBase"
            })
          })
        }
      })
    })]
  });
};